export const getStoryblokVersion = (): "draft" | "published" => {
	const config = useRuntimeConfig();

	return config.public.siteEnv === "staging" ? "draft" : "published";
};
